import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {},

  icon: {
    fontSize: theme.spacing(3.5),
    filter: `drop-shadow(${theme.spacing(0.25)} ${theme.spacing(0.25)} ${theme.spacing(0.25)} ${
      theme.palette.background.default
    })`,

    '&:hover': {
      strokeWidth: theme.spacing(0.2),
      stroke: theme.palette.primary.light,
      color: theme.palette.primary.light,
    },
  },
}));
